import {RouteConfig} from "vue-router";
import Home from "@/views/Home.vue";
import Access from "@/views/Access.vue";
// import ProjectRequest from "@/views/ProjectRequest.vue";
import Recruit from "@/views/Recruit.vue";
import Message from "@/views/Message.vue";
import Culture from "@/views/recruit/Culture.vue";
import SecurityPolicy from "@/views/SecurityPolicy.vue";
import NotFound from "@/views/NotFound.vue";
import {formedgeServicePageLink} from "@/functions/formedgeLink";
// DesignAtoms(開発用UIカタログ)は本番不要のため削除 (#277)

const routes: RouteConfig[] = [
  {
    path: "/",
    component: Home,
  },
  // {
  //   path: "/project-request",
  //   name: "ProjectRequest",
  //   component: ProjectRequest,
  //   meta: { title: 'sample' },
  // },
  {
    // サービス紹介ページは FormEdge で作成したページへ移行したため、旧URLは外部ページへ転送する
    path: "/service/formedge",
    beforeEnter() {
      window.location.replace(formedgeServicePageLink("legacy-service-page", "redirect"));
    },
  },
  {
    path: "/recruit",
    component: Recruit,
    meta: { title: '株式会社Value 採用情報' },
  },
  {
    path: "/recruit/culture",
    component: Culture,
    meta: { title: '株式会社Value 採用情報 - 文化・働く環境' },
  },
  {
    path: "/message",
    component: Message,
    meta: { title: '株式会社Value 代表挨拶' },
  },
  {
    path: "/access",
    component: Access,
    meta: { title: '株式会社Value オフィス所在地' },
  },
  {
    path: "/security-policy",
    component: SecurityPolicy,
    meta: { title: '株式会社Value 情報セキュリティ基本方針および個人情報保護方針' },
  },
  {
    // 未定義URLのフォールバック(404)
    path: "*",
    component: NotFound,
    meta: { title: '株式会社Value | ページが見つかりません' },
  },
];

export default routes;
